import { useEffect, useState } from "react";
import Hero from "@/components/Hero";
import SocialProof from "@/components/SocialProof";
import Courses from "@/components/Courses";
import SubscriptionCTA from "@/components/SubscriptionCTA";
import Features from "@/components/Features";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import LeadCapture from "@/components/LeadCapture";
import PaymentMethodModal from "@/components/PaymentMethodModal";
import Seo from "@/components/Seo";
import { courses as coursesApi } from "@/lib/api";

const Landing = ({ onOpenAuth }) => {
  const [list, setList] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);

  useEffect(() => {
    coursesApi.list().then(setList).catch(() => setList([]));
  }, []);

  const scrollToCourses = () => {
    document.getElementById("cursos")?.scrollIntoView({ behavior: "smooth" });
  };

  const handleBuy = (course) => setSelectedCourse(course);

  return (
    <main data-testid="landing-page">
      <Seo courses={list} />
      <Hero onCTA={scrollToCourses} />
      <SocialProof />
      <Courses courses={list} onBuy={handleBuy} />
      <SubscriptionCTA onOpenAuth={onOpenAuth} />
      <Features />
      <Testimonials />
      <LeadCapture />
      <FAQ />
      <PaymentMethodModal
        open={!!selectedCourse}
        course={selectedCourse}
        onClose={() => setSelectedCourse(null)}
      />
    </main>
  );
};

export default Landing;
